export const G = {
  username: 'username',
  password: 'password',
  token: 'streetprice-jwt',
  search: 'search',
} as const;

export const SCROLLING_OFFSET = 300;

export const powerInHpOptions = [50, 60, 70, 80, 100, 120, 150, 200, 300, 500] as const;
export const motoPowerInHpOptions = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 120, 150, 200, 250, 300, 500] as const;

export const carEngineDisplacementInCM3Options = [500, 1000, 1500, 2000, 3000, 4000, 5000, 10000] as const;
export const motoEngineDisplacementInCM3Options = [
  50, 125, 150, 200, 250, 300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 2000, 2500, 3000, 5000,
] as const;

export const pricesOptions = [
  0, 500, 1000, 1500, 2000, 5000, 10000, 20000, 30000, 50000, 75000, 100000, 150000, 500000, 999999,
] as const;

export const kmOptions = [
  0, 2500, 5000, 10000, 20000, 30000, 40000, 50000, 70000, 80000, 90000, 100000, 125000, 150000, 175000, 200000,
  1000000,
] as const;
